import {
    ENUM_FIELD_OPERATORS,
    NUMBER_FIELD_OPERATORS,
    STRING_FIELD_OPERATORS,
} from '../campaigns-filter.types';

export enum FIELD {
    STATUS = 'status',
    CAMPAIGNS = 'campaigns'
}

export type OPERATOR = ENUM_FIELD_OPERATORS | NUMBER_FIELD_OPERATORS | STRING_FIELD_OPERATORS;

export type VALUE = number | string | Array<string>;

export type FilterRule = {
    field: FIELD,
    operator: OPERATOR,
    value: VALUE,
}

export type Rules = Array<FilterRule>
